import { createSlice } from "@reduxjs/toolkit";
import { getStaffDetailById } from "../../api/staff";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getStaffIdSlice = createSlice({
  name: "getStaffById",
  initialState: data,
  reducers: {
   getStaffIdSlice(state) {
      state.isLoading = true;
    },
   getStaffIdSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getStaffIdSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getStaffIdSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});

export const getStaffIdHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(getStaffIdAction.getStaffIdSlice());
    const response: any = await getStaffDetailById(id);
    
    dispatch(getStaffIdAction.getStaffIdSliceSuccess(response));
  } catch (e: any) {
    dispatch(getStaffIdAction.getStaffIdSliceFailure(e?.response?.data));
  }
};

export default getStaffIdSlice.reducer;
export const getStaffIdAction = getStaffIdSlice.actions;
